import React from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const TeamComponent = ({ image, name, profession, alt }) => (
  <Col sm={6} lg={4} className="px-4 mb-5">
    <div className="text-center">
      <img src={image} alt={alt}></img>
    </div>
    <h4 className="text-center mt-3">
      <strong>{name}</strong>
    </h4>
    <p className="text-center">{profession}</p>
  </Col>
);

TeamComponent.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  profession: PropTypes.string,
  alt: PropTypes.string,
};

export default TeamComponent;